import { render, staticRenderFns } from "./new-Device.vue?vue&type=template&id=968e7d6a"
import script from "./new-Device.vue?vue&type=script&lang=js"
export * from "./new-Device.vue?vue&type=script&lang=js"
import style0 from "./new-Device.vue?vue&type=style&index=0&id=968e7d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports